const testimonials = [
  {
    name: "Margaret & Harold T.",
    role: "Retirees, Venice Golf & Country Club",
    highlight: "Rhine River cruise — Schengen validity rule surprise",
    story:
      "We have lived at Venice Golf & Country Club for eight years, and every winter we take one big trip. This year our travel club organized a Rhine River cruise from Amsterdam to Basel — castles, wine tastings, the whole experience. We paid in full in September to get the early booking discount through the club. In late February, three weeks before departure, the tour coordinator asked everyone to submit passport copies for the cruise line. Harold's passport expired in June — after the cruise ended. I figured we were fine since it was still valid during the trip. The coordinator corrected me immediately: the Schengen rule requires three months of validity beyond your departure date. We were three weeks from a $12,000 cruise that had been planned for over a year. I called Fast Passport Center in a panic. They processed Harold's expedited renewal and had it back to our Venice address in five business days. We made the cruise, saw every castle along the Rhine, and drank Riesling in Rudesheim. I had never heard of the three-month rule. Now I check every passport in our house before booking anything.",
    rating: 5,
    tag: "Luxury Travel",
  },
  {
    name: "The Brennan Family",
    role: "South Venice Residents",
    highlight: "Spring break Cancun trip — child's passport expired",
    story:
      "We booked an all-inclusive in Cancun for our two kids' spring break through a deal we found flying out of Tampa. We booked in November when the prices dropped — $219 round trip per person, we could not pass it up. Fast forward to mid-February, and my husband asked if the kids' passports were still good. Our daughter's was fine, but our son's had expired the previous August — he was 7 when it was issued, so it was only good for 5 years. We had no idea. We were four weeks from departure and thought we were in trouble. Fast Passport Center handled the child passport renewal with the parental consent forms, the in-person appearance requirements at the Sarasota post office, and everything else we did not understand. Our son had his new passport in eight days. The Cancun trip was amazing — the kids swam with dolphins and built sandcastles on the beach. We now check all four passports every October like clockwork. Never again.",
    rating: 5,
    tag: "Child Passport",
  },
  {
    name: "Dorothy L.",
    role: "Snowbird from Toronto, Winter Resident in Jacaranda West",
    highlight: "Emergency trip to Toronto for new grandchild — 72-hour renewal",
    story:
      "I have been wintering in Jacaranda West for fifteen years. I am from Toronto originally, and my daughter still lives there with her family. When she called to tell me my first great-grandchild was arriving three weeks early, I started packing immediately. Then I pulled out my passport to book the flight from SRQ and realized it had expired two months ago — I had not used it since my trip to London with the Venice Theatre group the previous winter. I was heartbroken. A neighbor in the community recommended Fast Passport Center. I called them on Tuesday morning, completely panicked. They arranged an acceptance appointment at the Venice post office that same afternoon, walked me through the emergency documentation, and had my new passport delivered to my door by Thursday evening. I was on a flight to Toronto Friday morning and held my great-granddaughter that afternoon. They gave me a miracle when I needed one most.",
    rating: 5,
    tag: "Emergency",
  },
];

export default function VeniceTestimonialsSection() {
  return (
    <section className="py-16 md:py-20 bg-[#F8F9FB]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-[#B22222] text-xs font-bold uppercase tracking-[0.15em] mb-3">
            Venice Client Stories
          </span>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Venice Travelers Say About Us
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white rounded-lg p-6 md:p-8 border border-gray-100 shadow-sm hover:shadow-md transition-all"
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#F6C344] text-sm"></i>
                ))}
              </div>

              <div className="inline-block bg-[#F6C344]/10 text-[#1A365D] text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full mb-4">
                {t.tag}
              </div>

              <p className="text-gray-600 text-sm leading-relaxed mb-6 italic">
                &ldquo;{t.story}&rdquo;
              </p>

              <div className="border-t border-gray-100 pt-4">
                <div className="font-semibold text-[#1A365D] text-sm">{t.name}</div>
                <div className="text-gray-500 text-xs">{t.role}</div>
              </div>

              <div className="mt-3 bg-[#1A365D]/5 rounded-md px-3 py-2">
                <p className="text-[#1A365D] text-xs font-semibold">{t.highlight}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}